export function generateStoreFrontUrl(retailerId, retailerSlug) {
  if (!retailerId) {
    return undefined;
  }
  const path = ['', 'store', retailerId];
  if (retailerSlug) {
    path.push(retailerSlug);
  }
  return path.join('/');
}